import { useState, useEffect, useContext, useRef } from 'react'
import Select from 'react-select';
import ContextStates from '../context/ContextStates';
import ReactToPrint from 'react-to-print';
import { FaPrint } from 'react-icons/fa'
import axios from 'axios';
import { Url } from './Url';
import { Link } from 'react-router-dom';


const ListadoProductosPedidos = () => {
    const [productos, setProductos] = useState([])
    const [zonas, setZonas] = useState([])
    const [zona, setZona] = useState(0)

    const { idUsuario, modify } = useContext(ContextStates)
    const componentRef = useRef();

    useEffect(() => {
        const consultaZonas = async () => {
            const formData = new FormData()
            formData.append("id", 1)
            try {
                const response = await axios({
                    url: Url + 'api/listZonas.php',
                    method: 'POST',
                    data: formData,
                })

                setZonas(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaZonas()
    }, [])


    useEffect(() => {
        const getProductosPedidos = async () => {
            
            if (zona!==0) {
                const formData = new FormData()
                formData.append('zona', zona.id);
                try {
                    const results = await axios({
                        url: Url + 'api/getProductosPedidos.php',
                        method: 'POST',
                        data: formData,
                    })
                    console.log(results)
                    if (typeof results.data.results !== 'undefined') {
                        setProductos(results.data.results)
                    }
                } catch (e) {
                    console.log(e)
                }
            }
        }
        getProductosPedidos()
    }, [modify, zona])


    return (
        <div className='w-full' ref={componentRef}>
            <h2 className='text-center text-3xl'>Listado de Productos para repartos</h2>
            <div className="w-1/2 mx-auto">
                <Select
                    options={zonas}
                    placeholder="Seleccione la zona"
                    onChange={(value) => setZona(value)}
                    name='sZona'
                />
            </div>

            <div className="transition-all w-full mt-3">
                <div className="w-full rounded-lg p-5 justify-center">
                </div>
                <div className="w-10/12 mx-auto py-5 px-2">
                    {typeof productos !== 'undefined' && productos.length>0 && (
                        <div className='w-full'>

                            <table className='w-full mx-auto'>
                                <thead>
                                    <tr className='p-1 bg-blue-400 text-white text-center'>
                                        <th>Producto</th>
                                        <th>Cantidad</th>
                                        <th className='print:hidden'>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        productos.map((item, index) => (
                                            <tr key={index} className={`hover:cursor-pointer hover:bg-slate-200 border-b border-gray-200 text-center ${item.saldo && item.saldo > 0 && item.saldo === item.total ? 'bg-red-300' : item.saldo > 0 && item.saldo < item.total ? 'bg-orange-300' : index % 2 === 0 ? 'bg-white ' : 'bg-slate-100'} )`}>
                                                <td>{item.producto}</td>
                                                <td>{item.cantidad}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
            <div className="w-10/12 mx-auto py-5">
                <ReactToPrint
                    trigger={() =>
                        <p
                            className="print:hidden hover:cursor-pointer w-1/3 sm:w-1/4 flex shadow-md p-3 mt-10 ml-3 bg-indigo-500 text-white hover:bg-indigo-400 transition-all uppercase font-bold rounded-lg"
                        >
                            <FaPrint className='mx-auto mt-1' />
                            <span className='mx-auto text-center'>
                                Imprimir Listado
                            </span>
                        </p>}
                    content={() => componentRef.current}
                />
            </div>
        </div>
    )
}

export default ListadoProductosPedidos